import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication
} from '@azure/msal-browser';

import { ENVIRONMENT } from '@env/environment';

const CONFIG = ENVIRONMENT.azureAdB2C;
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const msalConfig = {
  auth: {
    clientId: CONFIG.clientId,
    authority: CONFIG.b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [CONFIG.b2cPolicies.authorityDomain],
    redirectUri: '/',
    postLogoutRedirectUri: '/'
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string): void {
        switch (logLevel) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      allowNativeBroker: false,
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false
    }
  }
};

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

/**
 * MSAL Angular will automatically retrieve tokens for resources
 * added to protectedResourceMap. For more info, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/initialization.md#get-tokens-for-web-api-calls
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();

  protectedResourceMap.set(ENVIRONMENT.qApi.endpoint, ENVIRONMENT.qApi.scopes);
  protectedResourceMap.set(
    ENVIRONMENT.coreApi.endpoint,
    ENVIRONMENT.coreApi.scopes
  );
  // protect image processor api
  protectedResourceMap.set(
    ENVIRONMENT.imageProcessorsApi.endpoint,
    ENVIRONMENT.imageProcessorsApi.scopes
  );

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    authRequest: {
      authority: CONFIG.b2cPolicies.authorities.signUpSignIn.authority
    }
  };
}

/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes, you want the user to consent upon login, add them here as well.
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ENVIRONMENT.qApi.scopes,
      authority: CONFIG.b2cPolicies.authorities.signUpSignIn.authority
    },
    loginFailedRoute: '/error?errorType=login-error'
  };
}
